export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10 text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-5">
              <i className="ri-mail-send-line text-2xl md:text-3xl"></i>
            </div>

            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto">
              如果您有影片推荐建议、版权问题或合作意向，欢迎通过以下方式与被窝影院团队取得联系。我们珍视每一位影迷的反馈，将尽快回复您的来信。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-primary-600"></i>
                <span>contact@beiwomovie.com</span>
              </div>
              <span className="hidden sm:block text-foreground-300">|</span>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-wechat-line text-accent-600"></i>
                <span>beiwo_movie</span>
              </div>
            </div>

            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              提交反馈
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}